export const parseSaveClientErrorMessage = (value: string, fallback = ''): string => {
  if (value.includes('duplicate key value violates unique constraint')) {
    return 'Email is already being used by another client';
  } else if (value.includes('email address is already in use by another client')) {
    return 'This email address is already in use by another client';
  } else if (value.includes('Used as RSM Email')) {
    return 'Used as RSM Email';
  } else if (value.includes('provided phone numbers already assigned as partners phones')) {
    return 'Some of provided phone numbers already assigned as partners phones';
  } else if (value.includes('provided emails already assigned as partners emails')) {
    return 'Some of provided emails already assigned as partners emails';
  } else if (value.includes('emails contain emails that assigned to users')) {
    return 'That e-mail is already used by a team member';
  } else {
    return fallback;
  }
};
